import axios from "axios";
import User from "models/User";
import LoginResponse from "models/ApiResponse/LoginResponse";
import { GenericService, Service } from "./genericService";
import PublicUser from "models/PublicUser";

class UserService extends GenericService<User> implements Service<User> {
  constructor() {
    super("api/authentication");
  }

  updatePassword = async (password: string, confirmation: string) => {
    var result = await axios.post<any>(`${this.baseUrl}/update-password`,
      {
        password,
        confirmation
      });

    return result.data;
  }

  getPublic = async (userId: string): Promise<PublicUser | null> => {
    var r = await axios.get(`${this.baseUrl.replace('authentication', 'user')}/public/${userId}`);
    return r.data;
  }

  canViewPublic = async (userId: string): Promise<boolean> => {
    var r = await axios.get(`${this.baseUrl.replace('authentication', 'user')}/canView/${userId}`);
    return r.data;
  }

  getMinimal = async (userId: string, discussionId: number): Promise<any> => {
    var r = await axios.get(`${this.baseUrl.replace('authentication', 'user')}/minimal/${discussionId}/${userId}`);
    return r.data;
  }

  forgetPassword = async (email: string) => {
    var result = await axios.post<any>(`${this.baseUrl}/ForgotPassword`, { email });
    return result.data;
  }

  reinitPassword = async (email: string, password: string, token: string) => {
    var result = await axios.post<any>(`${this.baseUrl}/ResetPassword`, {
      email,
      token,
      newPassword: password
    });
    return result.data;
  }

  getProfilPicture = async (userId: string): Promise<string> => {
    const result = await axios.get(`${this.baseUrl}/${userId}/picture`);
    return result.data;
  };

  updateProfil = async (firstName: string, lastName: string, birthDay: Date, email: string, phoneNumber: string): Promise<void> => {
    await axios.post<any>(`${this.baseUrl}/description/add`,
      {
        firstName,
        lastName,
        birthDay,
        email,
        phoneNumber
      });
  }

  addDescription = async (description: string): Promise<void> => {
    await axios.post<any>(`${this.baseUrl}/description`,
      {
        value: description
      });
  }

  addDestination = async (destination: string): Promise<void> => {
    await axios.post<any>(`${this.baseUrl}/destination/add`,
      {
        value: destination
      });
  }

  removeDestination = async (destination: string): Promise<void> => {
    await axios.post<any>(`${this.baseUrl}/destination/delete`,
      {
        value: destination
      });
  }

  addStayType = async (stayType: string): Promise<void> => {
    await axios.post<any>(`${this.baseUrl}/stayType/add`,
      {
        value: stayType
      });
  }

  removeStayType = async (stayType: string): Promise<void> => {
    await axios.post<any>(`${this.baseUrl}/stayType/delete`,
      {
        value: stayType
      });
  }

  addTransport = async (transport: string): Promise<void> => {
    await axios.post<any>(`${this.baseUrl}/transport/add`,
      {
        value: transport
      });
  }

  removeTransport = async (transport: string): Promise<void> => {
    await axios.post<any>(`${this.baseUrl}/transport/delete`,
      {
        value: transport
      });
  }

  signIn = async (email: string, password: string): Promise<LoginResponse> => {
    const result = await axios.post<any>(`${this.baseUrl}/SignIn`, {
      email,
      password,
    });
    return result.data;
  };

  addUser = async (user: User): Promise<LoginResponse> => {
    const result = await axios.post<any>(`${this.baseUrl}`, user);
    return result.data;
  };

  getUserByEmail = async (email: string): Promise<User> => {
    const result = await axios.get(`${this.baseUrl}/GetUserByEmail`, {
      data: { email },
    });
    return result.data;
  };

  getCurrentUser = async (): Promise<User> => {
    const result = await axios.get(`${this.baseUrl}/GetCurrentUser`);
    return result.data;
  };

  addLog = async (log: string, template: string): Promise<void> => {
    await axios.post(`${this.baseUrl}/log`, { log, template });
  }
}

export default new UserService();
